import React, { useState } from "react";
import { AddFlex, CustomText, PrimaryActionButton } from "./reusableStyles";
import { Checkbox } from "@mui/material";

function FilterDrawerComponent({
  setClients,
  closeDialog,
  filters,
  setFilters,
}) {
  const [filter, setFilter] = useState(filters?.type);

  const handleSetFilter = (filterType) => {
    console.log(filterType === filter);
    if (filterType === filter) {
      return setFilter(null);
    }
    setFilter(filterType);
  };

  return (
    <AddFlex
      alignItems="flex-start"
      flexDirection="column"
      gap="12px"
      padding="30px"
    >
      <CustomText color="black" fontSize="20px">
        Select Filters
      </CustomText>
      <AddFlex
        gap="10px"
        onClick={() => {
          handleSetFilter("new");
        }}
      >
        <Checkbox sx={{ padding: "0px" }} checked={filter === "new"} />
        <CustomText color="black">
          New Customers (0 P & U / 0 Revenue)
        </CustomText>
      </AddFlex>
      <AddFlex
        gap="10px"
        onClick={() => {
          handleSetFilter("inactive");
        }}
      >
        <Checkbox sx={{ padding: "0px" }} checked={filter === "inactive"} />
        <CustomText color="black">
          Inavtive Customers (1 U & 0 P / 0 Revenue)
        </CustomText>
      </AddFlex>
      <AddFlex
        gap="10px"
        onClick={() => {
          handleSetFilter("revenueBooster");
        }}
      >
        <Checkbox
          sx={{ padding: "0px" }}
          checked={filter === "revenueBooster"}
        />
        <CustomText color="black">Revenue Booster (1 P / 0 Revenue)</CustomText>
      </AddFlex>
      <PrimaryActionButton
        onClick={() => {
          setFilters(filter);
          closeDialog();
        }}
      >
        Submit
      </PrimaryActionButton>
    </AddFlex>
  );
}

export default FilterDrawerComponent;
